import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complete-join',
  templateUrl: './complete-join.component.html',
  styleUrls: ['./complete-join.component.scss']
})
export class SCompleteJoinComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
